'use client'

import React from 'react'
import { useRegionFaqs } from '../../RegionContent'
import CollapsibleList from '../CollapsibleList'
import { getMatchScore } from '../../../utils/search'

function FaqCollapsibleList({ title, faqCategory, faqCategories, search = '', placeholderIfEmpty, sx }) {
  const allFaqs = useRegionFaqs()

  const categories = faqCategories && faqCategories.length ? faqCategories : (faqCategory ? [faqCategory] : [])

  title = title || getFaqTitle(categories)

  // clone the region FAQ collection to avoid mutating it in the next lines of code
  let faqs = allFaqs ? [...allFaqs] : []
  faqs = filterFAQs(faqs, categories, search)
  const collapsibleItems = faqs.map(f => ({
    _key: title + f._id,
    title: f.question,
    text: f.answer,
  }))

  if (collapsibleItems.length) {
    return <CollapsibleList small leftAligned title={title} collapsibleItems={collapsibleItems} searchTerm={search} sx={sx}/>
  } else if (placeholderIfEmpty) {
    return <CollapsibleList small leftAligned title={title} collapsibleItems={collapsibleItems} placeholderIfEmpty={placeholderIfEmpty} searchTerm={search} sx={sx}/>
  } else {
    return null
  }
}

const filterFAQs = (faqs, faqCategories, search) => {
  faqs = faqs.filter(f => !f.isHidden)

  if (faqCategories && faqCategories.length) {
    const categoriesTitles = faqCategories.map(c => c.title)
    let filteredByCategory = []
    categoriesTitles.forEach((title) => {
      const filtered = faqs.filter(f => f.category && f.category.title === title)
      filtered.sort(compareFAQs)
      filteredByCategory.push(...filtered)
    })

    faqs = filteredByCategory
  }

  if (search) {
    faqs = filterAndSortFAQsBySearchTerm(faqs, search)
  }

  return faqs
}

const filterAndSortFAQsBySearchTerm = (faqs, search) => {
  if (search) {
    faqs = faqs.map(f => ({
      ...f,
      matchScore: getMatchScore(f.question, search) + getMatchScore(getAnswerText(f.answer), search)
    }))
      .filter(f => f.matchScore && f.matchScore > 0)

    faqs.sort((f1, f2) => f2.matchScore - f1.matchScore)
  }

  return faqs
}

const compareFAQs = (f1, f2) => {
  if (f1.popularity && f2.popularity) {
    return f1.popularity - f2.popularity
  } else if (f1.popularity || f2.popularity) {
    return f1.popularity ? -1 : 1
  } else {
    return 0
  }
}

const getAnswerText = (answer) => {
  return answer
    .flatMap(a => a.children)
    .filter(a => !!a)
    .map(c => c.text)
    .filter(t => !!t)
    .join(' ')
}

const getFaqTitle = (faqCategories) => {
  if (faqCategories.length === 1) {
    return (faqCategories[0].titleOverride || faqCategories[0].title) + ' FAQs'
  } else {
    return 'All FAQs'
  }
}

export default FaqCollapsibleList
